import React from "react";
import Card from "./cards";

const SystemStatusTable = ({systemItems, softwareItems}) => {
    return (
        <table className="table table-borderless text-nowrap align-middle mb-0">
            <tbody>
            {/* System Information */}
            {systemItems && <tr className="bg-light">
                {systemItems.map((item, index) => (
                    <td key={index} className="rounded-start bg-transparent">
                        <div className="d-flex align-items-center gap-3">
                            <div>{item.icon}</div>
                            <div>
                                <h6 className="mb-0">{item.name}</h6>
                                <span className="fs-3">{item.value}</span>
                            </div>
                        </div>
                    </td>
                ))}
                <td className="bg-transparent"></td>
                <td className="text-end rounded-end bg-transparent">
                    <span className="badge bg-danger"></span>
                </td>
            </tr>}
            {systemItems && <tr><td style={{padding: "10px"}} colSpan="5"></td></tr>}

            {/* Software Updates */}
            {softwareItems.map((item, index) => (
                <>
                    <tr key={index} className="bg-light">
                        <td className="rounded-start bg-transparent">
                            <div className="d-flex align-items-center gap-3">
                                <div>{item.icon}</div>
                                <div>
                                    <h6 className="mb-0">{item.name}</h6>
                                </div>
                            </div>
                        </td>
                        <td className="bg-transparent">
                            <h3 className="mb-0">{item.current}</h3>
                            <span className="fs-3">{item?.currentTitle ?? ""}</span>
                        </td>
                        <td className="bg-transparent">
                            <h3 className="mb-0">{item.recommended}</h3>
                            <span className="fs-3">{item?.recommendedTitle ?? ""}</span>
                        </td>
                        <td className="text-end rounded-end bg-transparent">
                            <span className="badge bg-danger">{item.badge}</span>
                        </td>
                    </tr>
                    <tr><td style={{padding: "10px"}} colSpan="5"></td></tr>
                </>
            ))}

            </tbody>
        </table>
    );
};

export default SystemStatusTable;
